import { render, staticRenderFns } from "./CancelFail.vue?vue&type=template&id=2eaa40b0&scoped=true"
import script from "./CancelFail.vue?vue&type=script&lang=js"
export * from "./CancelFail.vue?vue&type=script&lang=js"
import style0 from "./CancelFail.vue?vue&type=style&index=0&id=2eaa40b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaa40b0",
  null
  
)

export default component.exports